import { useForm as createUseForm } from "@ant-design-vue/use";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../i18n";
import { createLoading } from "../../../utils/loading";
import { validateError } from "../../../utils/validate";

export const { isLoading, setIsLoading } = createLoading()

const CanvasDrawing = defineAsyncComponent(() => import('../../../components/input/template-builder/canvas-drawing/CanvasDrawing'))

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch((error) => {
            validateError({ error })
            throw error
        });
}

export const createForm = () => {
    return {
        base64: null,
    }
}

export const createRules = () => {
    return {
        base64: [],
    }
}

export const createFormTitle = () => {
    return i18n.global.t('components.report.signForApprove')
}

export const createField = ({ props, data }) => {
    const { viewOnly, signatureFile } = props
    const useForm = data.useForm
    const modelRef = useForm.modelRef
    return [
        {
            key: 'canvasDrawing',
            visible: () => true,
            colProp: () => ({ xs: 24 }),
            inputRender: () => {
                return <div class="text-center">
                    <CanvasDrawing
                        form={modelRef}
                        signatureFile={signatureFile}
                        options={state.options}
                        viewOnly={viewOnly}
                    ></CanvasDrawing>
                </div>
            },
        },
    ]
}

export const initForm = ({ props, data, refs }) => {
    data.form = createForm();
    data.rules = createRules();
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
}

export const state = reactive({
    count: 0,
    options: {
        eraser: false,
        disabled: false,
        fillShape: false,
        line: 3,
        color: '#000000',
        strokeType: 'dash',
        backgroundColor: '#FFFFFF',
        backgroundImage: null,
        watermark: null,
        saveAs: 'png',
        styles: { 'border': 'solid 1px #000' },
        lock: false,
    },
})